import fetchUsers from './getUsers';
import watchLockUser from './lockUser';
import watchDeleteUser from './deleteUser';

const watchUsers = [fetchUsers, watchLockUser, watchDeleteUser];

export default watchUsers;
